// src/serviceWorkerRegistration.ts

// Este archivo es una versión mínima del registrador de service worker de CRA
const isLocalhost = Boolean(
    window.location.hostname === 'localhost' ||
      // [::1] es localhost para IPv6.
      window.location.hostname === '[::1]' ||
      // 127.0.0.0/8 son direcciones localhost IPv4.
      window.location.hostname.match(
        /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
      )
  );
  
  type Config = {
    onSuccess?: (registration: ServiceWorkerRegistration) => void;
    onUpdate?: (registration: ServiceWorkerRegistration) => void;
  };
  
  export function register(config?: Config) {
    if ('serviceWorker' in navigator) {
      const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;
  
      if (isLocalhost) {
        // Esto es para desarrollo local: chequea si el service worker existe
        checkValidServiceWorker(swUrl, config);
        navigator.serviceWorker.ready.then(() => {
          console.log('App is being served cache-first by a service worker.');
        });
      } else {
        // En producción, registra el service worker normalmente
        registerValidSW(swUrl, config);
        
        // Verificar actualizaciones periódicamente (cada 5 minutos)
        setInterval(() => {
          checkForUpdates();
        }, 5 * 60 * 1000); // 5 minutos
      }
    }
  }
  
  function registerValidSW(swUrl: string, config?: Config) {
    navigator.serviceWorker
      .register(swUrl)
      .then((registration) => {
        if (registration.waiting) {
          config?.onUpdate?.(registration);
        } else {
          config?.onSuccess?.(registration);
        }

        // Detectar actualizaciones cuando se encuentran
        registration.addEventListener('updatefound', () => {
          const installingWorker = registration.installing;
          if (installingWorker == null) {
            return;
          }

          installingWorker.addEventListener('statechange', () => {
            if (installingWorker.state === 'installed') {
              if (navigator.serviceWorker.controller) {
                // Hay una nueva versión disponible
                config?.onUpdate?.(registration);
              } else {
                // Primera instalación
                config?.onSuccess?.(registration);
              }
            }
          });
        });
      })
      .catch((error) => {
        console.error('Error during service worker registration:', error);
      });
  }
  
  function checkValidServiceWorker(swUrl: string, config?: Config) {
    fetch(swUrl)
      .then((response) => {
        const contentType = response.headers.get('content-type');
        if (
          response.status === 404 ||
          (contentType != null && contentType.indexOf('javascript') === -1)
        ) {
          navigator.serviceWorker.ready.then((registration) => {
            registration.unregister().then(() => {
              window.location.reload();
            });
          });
        } else {
          registerValidSW(swUrl, config);
        }
      })
      .catch(() => {
        console.log(
          'No internet connection found. App is running in offline mode.'
        );
      });
  }
  
  export function checkForUpdates() {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.ready
        .then((registration) => {
          // Verificar si hay actualizaciones disponibles
          registration.update();
        })
        .catch((error) => {
          console.error('Error al verificar actualizaciones:', error);
        });
    }
  }

  export function unregister() {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.ready
        .then((registration) => {
          registration.unregister();
        })
        .catch((error) => {
          console.error(error.message);
        });
    }
  }